import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import EditContract from './EditContract';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const contract = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/store/contracts/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.contract : null;
};

const getEntityID = (props: RouteComponentProps<any>) => props.match.params.id;

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component contract={preloadedEntity} />;
    }

    const state = contract(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component contract={state.data} />;
  };
}

export default withState(EditContract);
